import { useState } from 'react'
import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.input?.border || '#d1d5db'};
  border-radius: 6px;
  background: ${({ theme }) => theme.input?.bg || '#fff'};
  min-height: 38px;
  cursor: text;
`

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: ${({ theme }) => theme.dropdown?.selectedBackground || '#eff6ff'};
  color: ${({ theme }) => theme.font?.label || '#374151'};
  border-radius: 4px;
  padding: 0.15rem 0.4rem;
  font-size: 0.8125rem;
  line-height: 1.4;
`

const RemoveBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  color: ${({ theme }) => theme.font?.subtle || '#6b7280'};
  font-size: 1rem;
  display: flex;
  align-items: center;
  &:hover { color: ${({ theme }) => theme.color?.danger || '#dc2626'}; }
`

const TagInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.875rem;
  min-width: 80px;
  flex: 1;
  color: ${({ theme }) => theme.font?.default || '#111827'};
`

const ChipInput = ({ name, value, onChange, placeholder, testId }) => {
  const [inputValue, setInputValue] = useState('')
  const { t } = useTranslation()
  const tags = Array.isArray(value) ? value : []

  const addTag = (raw) => {
    const tag = raw.trim()
    if (!tag || tags.includes(tag)) return
    onChange({ [name]: [...tags, tag] })
    setInputValue('')
  }

  const removeTag = (index) => {
    onChange({ [name]: tags.filter((_, i) => i !== index) })
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      addTag(inputValue)
    } else if (e.key === 'Backspace' && inputValue === '' && tags.length > 0) {
      removeTag(tags.length - 1)
    }
  }

  const handleBlur = () => {
    if (inputValue.trim()) addTag(inputValue)
  }

  return (
    <Wrapper onClick={() => document.getElementById(`chip-input-${name}`)?.focus()}>
      {tags.map((tag, i) => (
        <Chip key={i}>
          {tag}
          <RemoveBtn type="button" onClick={() => removeTag(i)}>×</RemoveBtn>
        </Chip>
      ))}
      <TagInput
        id={`chip-input-${name}`}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={tags.length === 0 ? t(placeholder) : ''}
        data-testid={testId}
      />
    </Wrapper>
  )
}

export default ChipInput
